import { render, staticRenderFns } from "./VendorBox.vue?vue&type=template&id=7b019ce6&scoped=true&lang=pug&"
import script from "./VendorBox.vue?vue&type=script&lang=ts&"
export * from "./VendorBox.vue?vue&type=script&lang=ts&"
import style0 from "./VendorBox.vue?vue&type=style&index=0&id=7b019ce6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b019ce6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRating } from 'vuetify/lib/components/VRating';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VFlex,VLayout,VRating,VSpacer})
